import { Button, Popconfirm } from 'antd';
import { apiErrorMessage } from '../../../shared/policies/api-error-message';
import { useToast } from '../../../shared/hooks/use-toast';
import { deactivateRateCard, type RateCardView } from '../rate-cards.api';

interface DeactivateRateCardButtonProps {
  card: RateCardView;
  onDeactivated: () => void;
}

/** Customer cards only: the standard card is the fallback spot business prices from, so there is nothing to offer on it. */
export function DeactivateRateCardButton({ card, onDeactivated }: DeactivateRateCardButtonProps) {
  const toast = useToast();
  if (card.customerId === null || !card.isActive) return null;

  async function deactivate() {
    try {
      await deactivateRateCard(card.id);
      toast.success(`Rate card for ${card.customerName ?? 'the customer'} deactivated`);
      onDeactivated();
    } catch (err) {
      toast.error(apiErrorMessage(err) ?? 'Could not deactivate the rate card');
    }
  }

  return (
    <Popconfirm title="Deactivate this rate card?" description="No new lines can be added to it. Its history stays." okText="Deactivate" onConfirm={deactivate}>
      <Button danger>Deactivate</Button>
    </Popconfirm>
  );
}
